module.exports = __webpack_public_path__ + "img/logo.24cffe5f.png";